import { useAmountWithConversion } from 'hooks/useAmountWithConversion';

export const Amount = (
  props: Parameters<typeof useAmountWithConversion>[0]
) => {
  const { main } = useAmountWithConversion(props);
  return main;
};
